import apiConfig from '../../../apiConfig';

export type StaffForStaffReserve = {
  id: number;
  nickname: string;
  icon_url?: string | null;
  bio?: string | null;
  role_name?: string | null;
  sns_links?: Array<{
    platform: string;
    url: string;
  }>;
};

type ListStaffsForStaffReserveResponse = {
  staffs: StaffForStaffReserve[];
};

export const fetchStaffsForStaffReserve = async (
  storeId: number,
): Promise<StaffForStaffReserve[]> => {
  const url = new URL(
    `${apiConfig.baseURL}/api/customer-app/reservation/by-staff/staffs`,
  );
  url.searchParams.set('storeId', String(storeId));

  const res = await fetch(url.toString(), { method: 'GET' });

  if (!res.ok) {
    throw new Error('Failed to fetch staffs (by-staff)');
  }

  const data = (await res.json()) as ListStaffsForStaffReserveResponse;
  return data.staffs ?? [];
};
